module.exports = __webpack_public_path__ + "img/6.22d16f8f.png";